import { render, staticRenderFns } from "./AddList.vue?vue&type=template&id=b3c6c5f2&scoped=true&lang=pug&"
import script from "./AddList.vue?vue&type=script&lang=js&"
export * from "./AddList.vue?vue&type=script&lang=js&"
import style0 from "./AddList.vue?vue&type=style&index=0&id=b3c6c5f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c6c5f2",
  null
  
)

export default component.exports